import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";
import styled from "styled-components";

import { CheckoutStatusResponse } from "@sso/types";
import { CircleLoading } from "@sso/ui/CircleLoading";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Message = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 100px;
`;

const ErrorMessage = styled(Message)`
  display: block;
  text-align: center;
  p {
    margin-bottom: 1rem;
  }
  border: 1px solid lightgray;
  padding: 30px;
`;

const PaymentReturn = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("orderId");
  const token = sessionStorage.getItem("payment-token") as string;
  const clientId = queryParams.get("clientId");
  const [order, setOrder] = useState<CheckoutStatusResponse | null>(null);
  const [isFulfilled, setIsFulfilled] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => {
    const checkOrderFulfillment = async () => {
      if (attempts === 15) {
        setErrorMessage(true);
        return;
      }

      if (attempts > 15) {
        return;
      }

      try {
        const headers: HeadersInit = {
          "Content-Type": "application/json",
          "X-ClientId": clientId || "",
        };

        if (token) {
          headers["X-Security-Token"] = token;
        }

        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/sso/Order/Fulfilled/${orderId}`, {
          method: "GET",
          headers: headers,
        });

        const fulfilled = await response.json();

        if (fulfilled) {
          setIsFulfilled(true);
        } else {
          setAttempts(prev => prev + 1);
        }
      } catch (error) {
        setAttempts(prev => prev + 1);
      }
    };
    setTimeout(checkOrderFulfillment, 5000);
  }, [attempts]);

  useEffect(() => {
    if (isFulfilled) {
      const fetchOrderDetails = async () => {
        try {
          const headers: HeadersInit = {
            "Content-Type": "application/json",
            "X-ClientId": clientId || "",
          };

          if (token) {
            headers["X-Security-Token"] = token;
          }

          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/sso/Checkout/${orderId}`, {
            method: "GET",
            headers: headers,
          });
          const data = await response.json();
          setOrder(data.result);
        } catch (error) {
          setErrorMessage(true);
        }
      };

      fetchOrderDetails();
    }
  }, [isFulfilled]);

  useEffect(() => {
    if (order && isFulfilled) {
      window.location.href = order.returnUrl;
    }
  }, [order, isFulfilled]);

  return (
    <Container>
      {errorMessage ? (
        <ErrorMessage>
          <p>We’re aware of an issue with your order and are looking into it.</p>
          <p>A member of our team will be in touch shortly.</p>
          <p>
            If you require immediate assistance please contact{" "}
            <span style={{ fontWeight: 800 }}>support@basemap.co.uk</span>
          </p>
        </ErrorMessage>
      ) : (
        <Message>
          <p>Please wait while we fulfill your order...</p>
          <CircleLoading />
        </Message>
      )}
    </Container>
  );
};

export default PaymentReturn;
